import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "lifecycle-for-edge-network-data"
    }}>{`Lifecycle for Edge Network data`}</h1>
    <p>{`When used with the `}<a parentName="p" {...{
        "href": "../edge-network/index.md"
      }}>{`Edge Network extension`}</a>{`, the following data is collected and sent to Platform on every application launch. An additional `}<a parentName="p" {...{
        "href": "/client-sdks/src/pages/edge/lifecycle-for-edge-network/index.md#configure-a-rule-to-forward-lifecycle-data-to-platform"
      }}>{`rule in the mobile property`}</a>{` is required to send Lifecycle data to the Edge Network extension.`}</p>
    <p>{`When the Analytics service is enabled in the datastream configuration, the XDM Lifecycle data is automatically mapped to Analytics. See the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/en/docs/analytics/implementation/aep-edge/xdm-var-mapping"
      }}>{`XDM object variable mapping to Adobe Analytics`}</a>{` documentation for more information.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`This data is not used with Lifecycle for Analytics. Instead, view the `}<a parentName="p" {...{
        "href": "../../home/base/mobile-core/lifecycle/metrics.md"
      }}>{`Lifecycle data`}</a>{` reference.`}</p>
    <h2 {...{
      "id": "lifecycle-application-foreground-data"
    }}>{`Lifecycle Application Foreground data`}</h2>
    <p>{`The following data is collected on each `}<a parentName="p" {...{
        "href": "../../home/base/mobile-core/lifecycle/event-reference.md#lifecycle-application-foreground"
      }}>{`Lifecycle Application Foreground`}</a>{` event. The structure of this data is defined in the Experience Data Model (XDM) field group `}<a parentName="p" {...{
        "href": "https://github.com/adobe/xdm/blob/master/docs/reference/adobe/experience/aep-mobile-lifecycle-details.schema.md"
      }}>{`AEP Mobile Lifecycle Details`}</a>{`.`}</p>
    <h3 {...{
      "id": "application"
    }}>{`Application`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Property`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Identifier of the application.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:name`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Name of the application.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:version`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Version of the application.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:isLaunch`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Indicates the application has launched. Every application foreground event sets `}<inlineCode parentName="td">{`isLaunch`}</inlineCode>{` to `}<inlineCode parentName="td">{`true`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:isInstall`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Indicates the application was installed. If `}<inlineCode parentName="td">{`true`}</inlineCode>{`, signifies the first launch of the application. The Experience Event's timestamp property can be used as the application's install date.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:isUpgrade`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Indicates the application was upgraded. If `}<inlineCode parentName="td">{`true`}</inlineCode>{`, signifies the first launch of the application after an upgrade.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`dc:language`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The language of the application to represent the user's linguistic, geographical, or cultural preferences for data presentation.`}</td>
        </tr>
      </tbody>
    </table>
    <InlineAlert variant="info" slots="text1, text2, text3, text4" mdxType="InlineAlert" />
    <p>{`For the `}<a parentName="p" {...{
        "href": "../edge-network/index.md"
      }}>{`Edge Network extension`}</a>{`, the `}<inlineCode parentName="p">{`xdm:isUpgrade`}</inlineCode>{` property, which identifies app upgrades, is collected within the `}<a parentName="p" {...{
        "href": "../../home/base/mobile-core/lifecycle/"
      }}>{`Lifecycle extension`}</a>{` by comparing version information at each app launch. Starting with Lifecycle extension for Android version 3.0.1 and Lifecycle extension for iOS version 5.1.0, there is an enhancement to the method of calculating this property.`}</p>
    <p><strong parentName="p">{`xdm:isUpgrade (Previous Method)`}</strong>{`
In Lifecycle extension for Android version (2.0.0 - 3.0.0) and Lifecycle extension for iOS version (4.0.0 - 5.0.0), the app upgrade event is detected by comparing the `}<inlineCode parentName="p">{`build number`}</inlineCode>{`s on iOS and the `}<inlineCode parentName="p">{`version name`}</inlineCode>{`s on Android.`}</p>
    <p><strong parentName="p">{`xdm:isUpgrade (New Method)`}</strong>{`
Starting with Lifecycle extension for Android version 3.0.1 and Lifecycle extension for iOS version 5.1.0, the app upgrade event is detected through comparisons of the `}<inlineCode parentName="p">{`xdm:version`}</inlineCode>{` properties which has the format  `}<inlineCode parentName="p">{`versionName (versionCode)`}</inlineCode>{` on Android and `}<inlineCode parentName="p">{`Version (Build)`}</inlineCode>{` on iOS.`}</p>
    <p>{`This change now more accurately detects when an application upgrade occurs. Applications which only change the build number on iOS or the version name on Android when upgrading, may see an increase in Lifecycle upgrade events. Other applications, however, should not see a change to Lifecycle upgrade events.`}</p>
    <h3 {...{
      "id": "device"
    }}>{`Device`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Property`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:type`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The type of device being tracked.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:manufacturer`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The name of the organization who owns the design and creation of the device.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:model`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The name of the model for the device.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:modelNumber`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The unique model number designation assigned by the manufacturer for this device.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:screenHeight`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`integer`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The number of vertical pixels of the device's active display in the default orientation.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:screenWidth`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`integer`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The number of horizontal pixels of the device's active display in the default orientation.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "environment"
    }}>{`Environment`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Property`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:type`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The type of the application environment.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:carrier`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A mobile network carrier or MNO, also known as a wireless service provider, wireless carrier, cellular company, or mobile network carrier.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:operatingSystem`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The name of the operating system used when the observation was made.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:operatingSystemVersion`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The full version identifier for the operating system used when the observation was made.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`dc:language`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The language of the environment to represent the user's linguistic, geographical, or cultural preferences for data presentation.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "lifecycle-application-background-data"
    }}>{`Lifecycle Application Background data`}</h2>
    <p>{`The following data is collected on each `}<a parentName="p" {...{
        "href": "../../home/base/mobile-core/lifecycle/event-reference.md#lifecycle-application-background"
      }}>{`Lifecycle Application Background`}</a>{` event. The structure of this data is defined in the Experience Data Model (XDM) field group `}<a parentName="p" {...{
        "href": "https://github.com/adobe/xdm/blob/master/docs/reference/adobe/experience/aep-mobile-lifecycle-details.schema.md"
      }}>{`AEP Mobile Lifecycle Details`}</a>{`.`}</p>
    <h3 {...{
      "id": "application-1"
    }}>{`Application`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Property`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:isClose`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Indicates the application was closed. Every application background event sets `}<inlineCode parentName="td">{`isClose`}</inlineCode>{` to `}<inlineCode parentName="td">{`true`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:closeType`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Type of application close, sent on application isClose. Type is `}<inlineCode parentName="td">{`close`}</inlineCode>{` on graceful termination of an application, or `}<inlineCode parentName="td">{`unknown`}</inlineCode>{` when application termination source is unknown, such as a forced close or application crash.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`xdm:sessionLength`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`integer`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Length of the application session in seconds. Usually referred as the time the application was in foreground. Will not be less than zero.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      